import { Box } from '@shopify/polaris';

const sizes = {
  'x-small': '0.25rem',
  small: '0.5rem',
  base: '1rem',
  medium: '2rem',
  large: '3rem',
  'x-large': '4rem',
  'xx-large': '5rem',
  'xxx-large': '6rem',
};

export const VerticalSpace = ({ size = 'base' }) => {
  return <Box minHeight={sizes[size]} />;
};
